import { mathService } from '@approvalmax/utils';
import { domain } from 'modules/data';
import { CheckAmaxPayPaymentDetailsDiscrepancies } from 'shared/data/webApp/v1';

import { SupplierWithItems } from './BillsInformation.types';

export const createEmptySupplierWithItems = (): SupplierWithItems => ({
    items: [],
    total: {
        amountDue: 0,
        paymentAmount: 0,
        currency: '',
        contact: { id: '', text: '' },
        paymentDetailsName: '',
        paymentDetailsStatus: domain.PaymentDetailsPaymentStatus.NotChecked,
        paymentDetailsId: '',
        firstBillRequestId: '',
    },
});

export const updateSupplierWithItems = (
    supplier: SupplierWithItems,
    item: domain.AmaxPayPaymentItem,
    paymentDetailsDiscrepanciesOnChecking: CheckAmaxPayPaymentDetailsDiscrepancies['response']['items'] | null
) => {
    if (item.contact) {
        const itemAmountDue = calculateItemAmountDue(item);

        supplier.items.push(item);
        supplier.total.amountDue = mathService.add(supplier.total.amountDue, itemAmountDue);
        supplier.total.paymentAmount += item.amount;
        supplier.total.currency = item.currency;
        supplier.total.contact = item.contact;
        supplier.total.paymentDetailsName = item.paymentDetails?.bankAccount.name || '';
        supplier.total.paymentDetailsStatus =
            item.paymentDetailsPaymentStatus ?? domain.PaymentDetailsPaymentStatus.NotChecked;
        supplier.total.paymentDetailsId = item.paymentDetails?.id || '';
        supplier.total.firstBillRequestId = item.xeroBillInvoiceRequestId;
        supplier.total.paymentDetailsStatus = getItemPaymentDetailsStatus(item, paymentDetailsDiscrepanciesOnChecking);
    }
};

const calculateItemAmountDue = (item: domain.AmaxPayPaymentItem) => {
    // INFO: li.amountDue - (li.amountInProcessing + li.amountOnApproval + li.amountAwaitingPayment)
    return mathService.subtract(
        item.amountDue,
        mathService.add(
            mathService.add(item.amountInProcessing ?? 0, item.amountOnApproval ?? 0),
            item.amountAwaitingPayment ?? 0
        )
    );
};

const getItemPaymentDetailsStatus = (
    item: domain.AmaxPayPaymentItem,
    paymentDetailsDiscrepanciesOnChecking: CheckAmaxPayPaymentDetailsDiscrepancies['response']['items'] | null
) => {
    return (
        paymentDetailsDiscrepanciesOnChecking?.find(
            (discrepancy) =>
                discrepancy.contactId === item.contact?.id &&
                discrepancy.paymentDetailsDiscrepancy.paymentDetailsId === item.paymentDetails?.id
        )?.paymentDetailsPaymentStatus ?? domain.PaymentDetailsPaymentStatus.NotChecked
    );
};
